import { createContext, useContext } from 'react';

export enum AppEnvironment {
  Office = 'office',
  Web = 'web',
}

export type AppEnvironmentState = {
  appEnvironment: AppEnvironment | undefined;
};

export const AppEnvironmentContext = createContext<AppEnvironmentState>({
  appEnvironment: undefined,
});

export const useAppEnvironmentContext = () => useContext(AppEnvironmentContext);
